import { Link, NavLink, useNavigate } from "react-router-dom";
import { useState } from "react";
import { MagnifyingGlass, List, X, SignOut } from "@phosphor-icons/react";
import { useAuth } from "../context/AuthContext";

const links = [
  { to: "/", label: "Home" },
  { to: "/news", label: "News" },
  { to: "/category/ATP", label: "ATP" },
  { to: "/category/WTA", label: "WTA" },
  { to: "/podcasts", label: "Podcast" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const navigate = useNavigate();
  const { user, logout } = useAuth();

  const submitSearch = (e) => {
    e.preventDefault();
    if (q.trim()) navigate(`/search?q=${encodeURIComponent(q.trim())}`);
    setOpen(false);
  };

  return (
    <header
      data-testid="top-navbar"
      className="sticky top-0 z-50 border-b border-white/10 bg-black/70 backdrop-blur-xl"
    >
      <div className="mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 lg:px-12">
        <Link to="/" data-testid="logo-home" className="font-display text-2xl font-bold tracking-tighter">
          <span className="text-white">BASELINE</span>
          <span className="text-[#D4FF00]"> / </span>
          <span className="text-white">BREAKDOWN</span>
        </Link>

        <nav className="hidden items-center gap-8 lg:flex">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              data-testid={`nav-${l.label.toLowerCase()}`}
              className={({ isActive }) =>
                `text-xs font-bold uppercase tracking-[0.2em] transition-colors ${
                  isActive ? "text-[#D4FF00]" : "text-white/70 hover:text-white"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <form onSubmit={submitSearch} className="hidden items-center gap-2 border border-white/15 px-3 py-2 md:flex">
            <MagnifyingGlass size={16} className="text-white/60" />
            <input
              data-testid="search-input"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search tennis..."
              className="w-40 bg-transparent text-sm text-white placeholder-white/40 outline-none"
            />
          </form>
          {user ? (
            <div className="hidden items-center gap-2 md:flex">
              <Link
                to="/admin"
                data-testid="nav-admin"
                className="border border-[#D4FF00] bg-[#D4FF00] px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-black transition-transform hover:-translate-y-0.5"
              >
                Dashboard
              </Link>
              <button
                data-testid="nav-logout"
                onClick={logout}
                className="flex items-center gap-1 border border-white/20 px-3 py-2 text-xs font-bold uppercase tracking-[0.2em] text-white/80 hover:border-white hover:text-white"
              >
                <SignOut size={14} /> Logout
              </button>
            </div>
          ) : (
            <Link
              to="/login"
              data-testid="nav-login"
              className="hidden border border-white/20 px-4 py-2 text-xs font-bold uppercase tracking-[0.2em] text-white/90 hover:border-[#D4FF00] hover:text-[#D4FF00] md:inline-block"
            >
              Admin
            </Link>
          )}
          <button
            onClick={() => setOpen(!open)}
            className="lg:hidden"
            data-testid="mobile-menu-toggle"
            aria-label="menu"
          >
            {open ? <X size={24} /> : <List size={24} />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-white/10 bg-black px-6 py-6 lg:hidden">
          <form onSubmit={submitSearch} className="mb-4 flex items-center gap-2 border border-white/15 px-3 py-2">
            <MagnifyingGlass size={16} className="text-white/60" />
            <input
              data-testid="search-input-mobile"
              value={q}
              onChange={(e) => setQ(e.target.value)}
              placeholder="Search tennis..."
              className="flex-1 bg-transparent text-sm text-white placeholder-white/40 outline-none"
            />
          </form>
          <div className="flex flex-col gap-4">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `text-sm font-bold uppercase tracking-[0.2em] ${
                    isActive ? "text-[#D4FF00]" : "text-white/70"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            {user ? (
              <>
                <Link to="/admin" onClick={() => setOpen(false)} className="text-sm font-bold uppercase tracking-[0.2em] text-[#D4FF00]">Dashboard</Link>
                <button onClick={() => { logout(); setOpen(false); }} className="text-left text-sm font-bold uppercase tracking-[0.2em] text-white/70">Logout</button>
              </>
            ) : (
              <Link to="/login" onClick={() => setOpen(false)} className="text-sm font-bold uppercase tracking-[0.2em] text-white/70">Admin Login</Link>
            )}
          </div>
        </div>
      )}
    </header>
  );
}
